<template>
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
        <span class="cursor-pointer flex items-center i18n-locale">
            <flag :iso="i18n_locale_img"></flag>
            <span class="ml-2">{{ getCurrentLocaleData.lang }}</span>
        </span>
        <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
            <vs-dropdown-item v-if="GET_SCHEDULE&&!GET_SCHEDULE.use_schedule" @click="updateLocale('ru')">
                <flag iso="ru"></flag>
                &nbsp; {{ this.$t("russian") }}
            </vs-dropdown-item>
            <vs-dropdown-item @click="updateLocale('en')">
                <flag iso="us"></flag>
                &nbsp; {{ this.$t("english") }}
            </vs-dropdown-item>
            <vs-dropdown-item v-if="GET_SCHEDULE&&!GET_SCHEDULE.use_schedule" @click="updateLocale('kk')">
                <flag iso="kz"></flag>
                &nbsp; {{ this.$t("kazak") }}
            </vs-dropdown-item>
            <vs-dropdown-item v-if="GET_SCHEDULE&&!GET_SCHEDULE.use_schedule" @click="updateLocale('ky')">
                <flag iso="kg"></flag>
                &nbsp; {{ this.$t("kyrgyz") }}
            </vs-dropdown-item>
        </vs-dropdown-menu>
    </vs-dropdown>
</template>

<script>

import { setFlatPickrLocale } from "@/widgets/flatPickrLocale";
import { mapGetters } from "vuex";
import i18n from "@/configs/VueI18n";

export default {
    name: "i18n",
    computed: {
        ...mapGetters({
            GET_SCHEDULE: "system_settings/GET_SCHEDULE",
        }),
        i18n_locale_img() {
            const locale = this.$i18n.locale;
            if (locale === "en") return "us";
            else if (locale === "ru") return "ru";
            else if (locale === "kk") return "kz";
            else if (locale === "ky") return "kg";
        },
        getCurrentLocaleData() {
            const locale = this.$i18n.locale;
            if (locale === "en") return { lang: this.$t("english") };
            else if (locale === "ru") return { lang: this.$t("russian") };
            else if (locale === "kk") return { lang: this.$t("kazak") };
            else if (locale === "ky") return { lang: this.$t("kyrgyz") };
        },
    },
    async created() {
        if(this.GET_SCHEDULE === null){
            await this.$store.dispatch('system_settings/GET_USE_SCHEDULE_OR_NOT')
        }
        const query = this.$route.query;
        if(this.GET_SCHEDULE.use_schedule && this.$i18n.locale !== 'en'){
            await this.$router.replace({
                params: { lang: 'en' },
                query: query,
            });
        };
        this.$moment.locale(this.$i18n.locale);
    },
    methods: {
        updateLocale(locale) {
            this.$i18n.locale = locale;
            this.$moment.locale(locale);
            const query = this.$route.query;
            this.$router.replace({
                params: { lang: locale },
                query: query,
            });
            // функция сделана для страницы ЦОО, так как там проблемы которые я не могу решить, извните.
            if (this.$route.name == 'coo') location.reload()

            setFlatPickrLocale(locale)

        },
    },
};
</script>
